import "./index.css";
import { useState, useEffect } from "react";
import LandingPageRoute from "@/routes/mockups.landing-page/route";
import AboutRoute from "@/routes/about/route";
import BlogRoute from "@/routes/blog/route";
import FAQsRoute from "@/routes/faqs/route";

function getPath() {
	return window.location.pathname;
}

export function App() {
	const [path, setPath] = useState(getPath);

	useEffect(() => {
		const onPop = () => setPath(getPath());
		window.addEventListener("popstate", onPop);
		return () => window.removeEventListener("popstate", onPop);
	}, []);

	switch (path) {
		case "/about":
			return <AboutRoute />;
		case "/blog":
			return <BlogRoute />;
		case "/faqs":
			return <FAQsRoute />;
		default:
			return <LandingPageRoute />;
	}
}

export default App;
